module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p4-06f6ea17358b76d9e73eeb13c94f19f6.png";